import {
  syncSkuCatalogFromListingsApi,
  getSkuCatalogSyncStatusApi,
  getSkuManagementSettingsApi,
  updateSkuManagementSettingsApi,
  startEbayItemDetailsEnrichmentApi,
  getEbayEnrichmentStatusApi,
  startEbaySkuDataSyncApi,
  getEbaySkuDataSyncStatusApi,
  getSkuItemsOverviewApi,
  getSkuItemsPageApi,
} from './sku-management.api';

export const getCatalogSyncStatusReducers = (builder) => {
  builder
    .addCase(getSkuCatalogSyncStatusApi.pending, (state) => {
      state.getCatalogSyncStatus = 'pending';
    })
    .addCase(getSkuCatalogSyncStatusApi.fulfilled, (state, { payload }) => {
      state.getCatalogSyncStatus = 'fulfilled';
      state.catalogSyncStatus = payload;
    })
    .addCase(getSkuCatalogSyncStatusApi.rejected, (state, action) => {
      state.getCatalogSyncStatus = 'rejected';
      state.error =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not load catalog sync status';
    });
};

export const syncCatalogFromListingsReducers = (builder) => {
  builder
    .addCase(syncSkuCatalogFromListingsApi.pending, (state) => {
      state.syncCatalogFromListingsStatus = 'pending';
    })
    .addCase(syncSkuCatalogFromListingsApi.fulfilled, (state, { payload }) => {
      state.syncCatalogFromListingsStatus = 'fulfilled';
      state.lastCatalogSyncResponse = payload;
      state.error = null;
    })
    .addCase(syncSkuCatalogFromListingsApi.rejected, (state, action) => {
      state.syncCatalogFromListingsStatus = 'rejected';
      state.error =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not start SKU catalog sync';
    });
};

export const skuManagementSettingsReducers = (builder) => {
  builder
    .addCase(getSkuManagementSettingsApi.pending, (state) => {
      state.getSkuManagementSettingsStatus = 'pending';
    })
    .addCase(getSkuManagementSettingsApi.fulfilled, (state, { payload }) => {
      state.getSkuManagementSettingsStatus = 'fulfilled';
      state.skuManagementSettings = payload;
    })
    .addCase(getSkuManagementSettingsApi.rejected, (state, action) => {
      state.getSkuManagementSettingsStatus = 'rejected';
      state.settingsError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not load SKU management settings';
    })
    .addCase(updateSkuManagementSettingsApi.pending, (state) => {
      state.updateSkuManagementSettingsStatus = 'pending';
    })
    .addCase(updateSkuManagementSettingsApi.fulfilled, (state, { payload }) => {
      state.updateSkuManagementSettingsStatus = 'fulfilled';
      state.skuManagementSettings = payload;
      state.settingsError = null;
    })
    .addCase(updateSkuManagementSettingsApi.rejected, (state, action) => {
      state.updateSkuManagementSettingsStatus = 'rejected';
      state.settingsError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not save SKU management settings';
    });
};

export const ebayEnrichmentReducers = (builder) => {
  builder
    .addCase(getEbayEnrichmentStatusApi.pending, (state) => {
      state.getEbayEnrichmentStatusRequest = 'pending';
    })
    .addCase(getEbayEnrichmentStatusApi.fulfilled, (state, { payload }) => {
      state.getEbayEnrichmentStatusRequest = 'fulfilled';
      state.ebayEnrichmentStatus = payload;
    })
    .addCase(getEbayEnrichmentStatusApi.rejected, (state, action) => {
      state.getEbayEnrichmentStatusRequest = 'rejected';
      state.ebayEnrichmentError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not load eBay enrichment status';
    })
    .addCase(startEbayItemDetailsEnrichmentApi.pending, (state) => {
      state.startEbayEnrichmentStatus = 'pending';
    })
    .addCase(startEbayItemDetailsEnrichmentApi.fulfilled, (state, { payload }) => {
      state.startEbayEnrichmentStatus = 'fulfilled';
      state.lastEbayEnrichmentStartResponse = payload;
      state.ebayEnrichmentError = null;
    })
    .addCase(startEbayItemDetailsEnrichmentApi.rejected, (state, action) => {
      state.startEbayEnrichmentStatus = 'rejected';
      state.ebayEnrichmentError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not start eBay enrichment';
    });
};

export const ebaySkuDataSyncReducers = (builder) => {
  builder
    .addCase(getEbaySkuDataSyncStatusApi.pending, (state) => {
      state.getEbaySkuDataSyncStatusRequest = 'pending';
    })
    .addCase(getEbaySkuDataSyncStatusApi.fulfilled, (state, { payload }) => {
      state.getEbaySkuDataSyncStatusRequest = 'fulfilled';
      state.ebaySkuDataSyncStatus = payload;
    })
    .addCase(getEbaySkuDataSyncStatusApi.rejected, (state, action) => {
      state.getEbaySkuDataSyncStatusRequest = 'rejected';
      state.ebaySkuDataSyncError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not load eBay SKU data sync status';
    })
    .addCase(startEbaySkuDataSyncApi.pending, (state) => {
      state.startEbaySkuDataSyncStatus = 'pending';
    })
    .addCase(startEbaySkuDataSyncApi.fulfilled, (state, { payload }) => {
      state.startEbaySkuDataSyncStatus = 'fulfilled';
      state.lastEbaySkuDataSyncStartResponse = payload;
      state.ebaySkuDataSyncError = null;
    })
    .addCase(startEbaySkuDataSyncApi.rejected, (state, action) => {
      state.startEbaySkuDataSyncStatus = 'rejected';
      state.ebaySkuDataSyncError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not start eBay SKU data sync';
    });
};

export const skuItemsOverviewReducers = (builder) => {
  builder
    .addCase(getSkuItemsOverviewApi.pending, (state) => {
      state.getSkuItemsOverviewStatus = 'pending';
    })
    .addCase(getSkuItemsOverviewApi.fulfilled, (state, { payload }) => {
      state.getSkuItemsOverviewStatus = 'fulfilled';
      state.skuItemsOverview = payload;
    })
    .addCase(getSkuItemsOverviewApi.rejected, (state, action) => {
      state.getSkuItemsOverviewStatus = 'rejected';
      state.itemsPageError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not load SKU overview';
    });
};

export const skuItemsPageReducers = (builder) => {
  builder
    .addCase(getSkuItemsPageApi.pending, (state) => {
      state.getSkuItemsPageStatus = 'pending';
    })
    .addCase(getSkuItemsPageApi.fulfilled, (state, { payload }) => {
      state.getSkuItemsPageStatus = 'fulfilled';
      state.skuItemsPage = payload;
      state.itemsPageError = null;
    })
    .addCase(getSkuItemsPageApi.rejected, (state, action) => {
      state.getSkuItemsPageStatus = 'rejected';
      state.itemsPageError =
        action?.payload?.message ||
        action?.error?.message ||
        'Could not load SKU items';
    });
};
